import { ClientService } from 'src/app/base/services/client/client.service';
import { Component, ViewChild } from '@angular/core';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { ParkingCardGridComponent } from '../shared/parking-card-grid.component';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { ClientAutocompleteComponent } from 'src/app/base/shared/client-autocomplete/client-autocomplete.component';
import { ParkingCardService } from '../shared/parking-card.service';

@Component({
  selector: 'app-parking-card-admin',
  imports: [TitleBarComponent, ParkingCardGridComponent, ClientAutocompleteComponent],
  templateUrl: './parking-card-admin.component.html',
  styleUrl: './parking-card-admin.component.scss'
})
export class ParkingCardAdminComponent {

  @ViewChild(ParkingCardGridComponent)
  private parkingCardGridComponent: ParkingCardGridComponent;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
      this.parkingCardService.selectedClientId = value?.id;
      if (this.parkingCardGridComponent) {
        this.parkingCardGridComponent.refreshGrid();
      }
    }
  }

  constructor( private clientService: ClientService,
               private parkingCardService: ParkingCardService) {
    this.parkingCardService.resetService();
    if (this.clientService.selectedClient) {
      this.parkingCardService.selectedClientId = this.clientService.selectedClient.id;
    }
  }

}
